import { Link } from 'react-router-dom';

export default function SeoContentSection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-4xl mx-auto">
        <article>
          <header className="mb-8 text-center">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
              Руководство
            </span>
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">
              Что такое <strong>YOYBUY Spreadsheet</strong> и как он работает
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              Полное руководство по использованию системы заказов из Китая
            </p>
          </header>

          <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 space-y-5">
            <section>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-3">
                Что такое YOYBUY Spreadsheet
              </h3>
              <p className="text-sm md:text-base leading-relaxed">
                <strong>YOYBUY Spreadsheet</strong> — это инновационная система заказов товаров из Китая, построенная на использовании структурированных таблиц. В отличие от обычных агентов, где каждый заказ оформляется вручную через чат, YOYBUY Spreadsheet позволяет вам добавлять товары в единую таблицу, отслеживать статус каждого заказа и полностью контролировать процесс покупки и доставки. Это значительно экономит время и снижает вероятность ошибок при оформлении.
              </p>
            </section>

            <section>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-3">
                Как работает система YOYBUY Spreadsheet
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 mb-4">
                {[
                  { step: '01', title: 'Поиск товара', desc: 'Найдите нужный товар на Taobao, 1688 или других китайских площадках.' },
                  { step: '02', title: 'Добавление в таблицу', desc: 'Внесите данные о товаре в YOYBUY Spreadsheet: ссылку, размер, цвет, количество.' },
                  { step: '03', title: 'Выкуп товара', desc: 'YOYBUY выкупает товар у продавца и проверяет его соответствие заказу.' },
                  { step: '04', title: 'Доставка', desc: 'После проверки качества товар отправляется международной доставкой в вашу страну.' },
                ].map((item) => (
                  <div key={item.step} className="flex gap-3 p-4 rounded-lg bg-background-50 border border-background-200/50">
                    <span className="flex-shrink-0 w-8 h-8 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center text-xs font-bold">
                      {item.step}
                    </span>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h4>
                      <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-3">
                Преимущества YOYBUY Spreadsheet
              </h3>
              <div className="overflow-x-auto rounded-lg border border-background-200/70">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="bg-background-200/50">
                      <th className="text-left px-4 py-3 font-semibold text-foreground-800 text-xs md:text-sm">Параметр</th>
                      <th className="text-left px-4 py-3 font-semibold text-foreground-800 text-xs md:text-sm">YOYBUY Spreadsheet</th>
                      <th className="text-left px-4 py-3 font-semibold text-foreground-800 text-xs md:text-sm">Обычный заказ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-t border-background-100">
                      <td className="px-4 py-2.5 text-xs md:text-sm text-foreground-700">Скорость оформления</td>
                      <td className="px-4 py-2.5 text-xs md:text-sm text-accent-700 font-medium">Быстро</td>
                      <td className="px-4 py-2.5 text-xs md:text-sm text-foreground-500">Медленно</td>
                    </tr>
                    <tr className="border-t border-background-100">
                      <td className="px-4 py-2.5 text-xs md:text-sm text-foreground-700">Количество ошибок</td>
                      <td className="px-4 py-2.5 text-xs md:text-sm text-accent-700 font-medium">Минимальное</td>
                      <td className="px-4 py-2.5 text-xs md:text-sm text-foreground-500">Частые</td>
                    </tr>
                    <tr className="border-t border-background-100">
                      <td className="px-4 py-2.5 text-xs md:text-sm text-foreground-700">Удобство</td>
                      <td className="px-4 py-2.5 text-xs md:text-sm text-accent-700 font-medium">Высокое</td>
                      <td className="px-4 py-2.5 text-xs md:text-sm text-foreground-500">Низкое</td>
                    </tr>
                    <tr className="border-t border-background-100">
                      <td className="px-4 py-2.5 text-xs md:text-sm text-foreground-700">Контроль заказов</td>
                      <td className="px-4 py-2.5 text-xs md:text-sm text-accent-700 font-medium">Полный</td>
                      <td className="px-4 py-2.5 text-xs md:text-sm text-foreground-500">Частичный</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-3">
                Какие товары можно заказать через YOYBUY Spreadsheet
              </h3>
              <p className="text-sm md:text-base leading-relaxed mb-3">
                Через <strong>YOYBUY Spreadsheet</strong> можно заказать практически любые товары из Китая. Наиболее популярные категории включают одежду, обувь, аксессуары, электронику, товары для дома и многое другое. Система особенно удобна для оптовых закупок и регулярных заказов, когда важно отслеживать множество позиций одновременно.
              </p>
              <div className="flex flex-wrap gap-2">
                {['Одежда', 'Обувь', 'Аксессуары', 'Электроника', 'Сумки', 'Парфюмерия', 'Джерси', 'Головные уборы'].map((tag) => (
                  <span key={tag} className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                    {tag}
                  </span>
                ))}
              </div>
            </section>

            <section>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-3">
                Безопасность и надёжность
              </h3>
              <p className="text-sm md:text-base leading-relaxed">
                <strong>YOYBUY Spreadsheet</strong> обеспечивает полную безопасность ваших заказов. Каждый товар проходит проверку качества перед отправкой. В случае брака или несоответствия описанию предусмотрен возврат средств. Служба поддержки работает с каждым клиентом индивидуально, помогая решить любые вопросы на всех этапах — от выбора товара до получения посылки.
              </p>
            </section>
          </div>

          <div className="mt-8 md:mt-10 text-center">
            <Link
              to="/blog/yoybuy-spreadsheet-instruktsiya"
              className="whitespace-nowrap inline-flex items-center gap-2 px-6 md:px-8 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm md:text-base hover:bg-accent-600 transition-all duration-300 cursor-pointer"
            >
              <i className="ri-article-line w-4 h-4 md:w-5 md:h-5 flex items-center justify-center" />
              Читать подробное руководство
            </Link>
          </div>
        </article>
      </div>
    </section>
  );
}